import { appAccessControlConstants } from 'Constants/appAccessControl.constants';
import { alterQueryRequest, calculatePaginationPage, findCurrentPageRequest, queryParser } from 'Helpers/urlform'
import { getTimezoneName, handleApiError } from 'Helpers';
import { toast as toastr } from 'react-toastify';
import Request from 'Services/request';

// Get Users Action
export const usersInitialState = () => {
    return {
        totalRecords: undefined,
        currentPage: 1,
        loading: false,
        error: false,
        responseData: []
    }
}
const appAccessControlUsersRequest = () => {
    return {
        type: appAccessControlConstants.USERS_REQUEST,
        payload:{
            loading: true,
            error: false
        }
    }
}

const appAccessControlUsersFailed = (message) => {
    return {
        type: appAccessControlConstants.USERS_FAILURE,
        payload:{
            loading: false,
            error: true,
            message
        }
    }
}

const appAccessControlUsersSuccess = (data) => {
    return {
        type: appAccessControlConstants.USERS_SUCCESS,
        payload: {
            ...usersInitialState(),
            ...(data || {})
        }
    }
}

export const fetchAppAccessControlUsers = (SearchArray) => {
    let url = '/appaccess/list';
    SearchArray = [ ...(SearchArray || []) , { id:'zone', value: getTimezoneName() } ]
    if(SearchArray && SearchArray.length > 0 ) {
        url = queryParser(url,SearchArray);
    } 
    const currentPage = findCurrentPageRequest(SearchArray);

    return async (dispatch) => {
        dispatch(appAccessControlUsersRequest());
        await Request.get(url, {})
            .then((response) => {
                const { data, count, totalRecords } = response;
                dispatch(appAccessControlUsersSuccess({ responseData: data || [], count: count || 0, totalRecords, currentPage }));
            })
            .catch((error) => {
                if(error) {
                    handleApiError(error);
                    dispatch(appAccessControlUsersFailed(error.toString()));
                }
            });
    };
}
// Add User Actions
export const addUserInitialstate = () => {
    return {
        loading: false,
        error: false,
        message: null
    }
}
const appAccessControlAddUserRequest = () => {
    return {
        type: appAccessControlConstants.ADD_USER_REQUEST,
        payload:{
            loading: true,
            error: false,
            message: null
        }
    }
}

const appAccessControlAddUserFailed = (message) => {
    return {
        type: appAccessControlConstants.ADD_USER_FAILURE,
        payload:{
            loading: false,
            error: true,
            message
        }
    }
}

const appAccessControlAddUserSuccess = (message) => {
    return {
        type: appAccessControlConstants.ADD_USER_SUCCESS,
        payload: {
            ...addUserInitialstate()
        }
    }
}

export const appAccessControlAddUserAction = (inputPayload = {}, listFilterArray) => {
    return (dispatch) => {
        dispatch(appAccessControlAddUserRequest());
        Request.create('/appaccess', { ...inputPayload })
        .then((response) => {
            const { message, status } = response;
            toastr.dismiss();
            if(status === 200){
                dispatch(appAccessControlAddUserSuccess());
                // Need to call fetch user to show updated list
                dispatch(fetchAppAccessControlUsers(listFilterArray));
                toastr.success(message);
            }
            else{
                dispatch(appAccessControlAddUserFailed(message));
                toastr.error(message);
            }
        })
        .catch((error) => {
            if(error) {
                handleApiError(error);
                dispatch(appAccessControlAddUserFailed(error.toString()));
            }
        })
    }
}

// Enable/Disable App Access Control Action
export const accessControlSwitchInitialstate = () => {
    return {
        loading: false,
        error: false,
        message: null,
        isEnabled: false
    }
}
const appAccessControlSwitchRequest = () => {
    return {
        type: appAccessControlConstants.ACCESS_GRANT_REQUEST,
        payload:{
            loading: true,
            error: false,
            message: null
        }
    }
}

const appAccessControlSwitchFailed = (message) => {
    return {
        type: appAccessControlConstants.ACCESS_GRANT_FAILURE,
        payload:{
            loading: false,
            error: true,
            message
        }
    }
}

const appAccessControlSwitchSuccess = (isEnabled) => {
    return {
        type: appAccessControlConstants.ACCESS_GRANT_SUCCESS,
        payload: {
            ...accessControlSwitchInitialstate(),
            isEnabled
        }
    }
}

export const getAppAccessControlSwitchAction = () => {
    return (dispatch) => {
        dispatch(appAccessControlSwitchRequest());
        Request.get('/appaccess/control')
        .then((response) => {
            const { data } = response;
            dispatch(appAccessControlSwitchSuccess(data.isEnabled));
        })
        .catch((error) => {
            if(error) {
                handleApiError(error);
                dispatch(appAccessControlSwitchFailed(error.toString()));
            }
        })
    }
}

export const updateAppAccessControlSwitchAction = (isEnabled) => {
    return (dispatch) => {
        dispatch(appAccessControlSwitchRequest());
        Request.update('/appaccess/control', { isEnabled })
        .then((response) => {
            const { message } = response;
            dispatch(appAccessControlSwitchSuccess(isEnabled));
            toastr.dismiss();
            toastr.success(message);
        })
        .catch((error) => {
            if(error) {
                handleApiError(error);
                dispatch(appAccessControlSwitchFailed(error.toString()));
            }
        })
    }
}

// Delete User Actions
export const deleteUserInitialstate = () => {
    return {
        loading: false,
        error: false,
        message: null,
        userId: undefined
    }
}
const appAccessControlDeleteUserRequest = () => {
    return {
        type: appAccessControlConstants.DELETE_USER_REQUEST,
        payload:{
            ...deleteUserInitialstate(),
            loading: true
        }
    }
}

const appAccessControlDeleteUserFailed = (message) => {
    return {
        type: appAccessControlConstants.DELETE_USER_FAILURE,
        payload:{
            ...deleteUserInitialstate(),
            error: true,
            message
        }
    }
}

const appAccessControlDeleteUserSuccess = (id) => {
    return {
        type: appAccessControlConstants.DELETE_USER_SUCCESS,
        payload: {
            ...deleteUserInitialstate(),
            userId: id
        }
    }
}

export const appAccessControlDeleteUserAction = (id, searchArray, totalRecords,currentPage) => {
    const ids = Array.isArray(id) ? id : [ id ];
    const updateSearchArray = calculatePaginationPage(searchArray, totalRecords, currentPage, ids.length);
    return (dispatch) => {
        dispatch(appAccessControlDeleteUserRequest());
        Request.remove('/appaccess', { ids })
        .then((response) => {
            const { message } = response;
            const userId = Array.isArray(id) ? undefined : id;
            dispatch(appAccessControlDeleteUserSuccess(userId));
            // Need to call fetch user to show updated list
               dispatch(fetchAppAccessControlUsers(updateSearchArray));
               toastr.dismiss();
               toastr.success(message);
        })
        .catch((error) => {
            if(error) {
                handleApiError(error);
                dispatch(appAccessControlDeleteUserFailed(error.toString()));
            }
        })
    }
}

// Import user
export const importUsersInitialstate = () => {
    return {
        loading: false,
        error: false,
        data: undefined
    }
}

const appAccessControlImportUsersRequest = () => {
    return {
        type: appAccessControlConstants.IMPORT_USERS_REQUEST,
        payload:{
            loading: true,
            error: false,
            message: null
        }
    }
}

const appAccessControlImportUsersFailed = (message) => {
    return {
        type: appAccessControlConstants.IMPORT_USERS_FAILURE,
        payload:{
            loading: false,
            error: true,
            message
        }
    }
}

export const appAccessControlImportUsersSuccess = (data) => {
    return {
        type: appAccessControlConstants.IMPORT_USERS_SUCCESS,
        payload: {
            ...importUsersInitialstate(),
            data
        }
    }
}

const appAccessControlImportUsersError = (importId, fileName) => {
    return (dispatch) => {
        Request.get(`/appaccess/import/error/${ importId }`)
        .then((response) => {
            // Display the export success here
            const url = window.URL.createObjectURL(response);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `${ fileName }-Result_${ (new Date()).getTime() }.csv`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            if(error) {
                handleApiError(error);
            }
        })
    }
}

export const appAccessControlImportUsersAction = (file, listFilterArray) => {
    let fileName = file.name;
    fileName = fileName.replace(/\.[^/.]+$/, '');
    return (dispatch) => {
        dispatch(appAccessControlImportUsersRequest());
        Request.create('/appaccess/import', file)
        .then((response) => {
            const { data: { importId, ...restData } = {} } = response;
            if(importId){
                dispatch(appAccessControlImportUsersError(importId, fileName));
            }
            dispatch(appAccessControlImportUsersSuccess(restData));
            if(restData.successCount){
                // Need to call fetch user to show updated list
                dispatch(fetchAppAccessControlUsers(listFilterArray));
            }
        })
        .catch((error) => {
            if(error) {
                handleApiError(error);
                dispatch(appAccessControlImportUsersFailed(error.toString()));
            }
        })
    }
}

// Download sample CSV
export const downloadSampleCsvInitialstate = () => {
    return {
        loading: false,
        error: false,
        message: null
    }
}

const aacDownloadSampleCsvRequest = () => {
    return {
        type: appAccessControlConstants.DOWNLOAD_SAMPLE_CSV_REQUEST,
        payload:{
            loading: true,
            error: false,
            message: null
        }
    }
}

const aacDownloadSampleCsvFailed = (message) => {
    return {
        type: appAccessControlConstants.DOWNLOAD_SAMPLE_CSV_FAILURE,
        payload:{
            loading: false,
            error: true,
            message
        }
    }
}
const aacDownloadSampleCsvSuccess = () => {
    return {
        type: appAccessControlConstants.DOWNLOAD_SAMPLE_CSV_SUCCESS,
        payload: {
            ...downloadSampleCsvInitialstate()
        }
    }
}

export const aacDownloadSampleCsvAction = () => {
    return (dispatch) => {
        dispatch(aacDownloadSampleCsvRequest());
        Request.get('/appaccess/import/sample')
        .then((response) => {
            dispatch(aacDownloadSampleCsvSuccess());
            // Display the export success here
            const url = window.URL.createObjectURL(response);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `sample.csv`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            if(error) {
                handleApiError(error);
                dispatch(aacDownloadSampleCsvFailed(error.toString()));
            }
        })
    }
}

// Export CSV
export const exportUsersInitialstate = () => {
    return {
        loading: false,
        error: false,
        message: null
    }
}

const aacExportUsersRequest = () => {
    return {
        type: appAccessControlConstants.EXPORT_USERS_REQUEST,
        payload:{
            loading: true,
            error: false,
            message: null
        }
    }
}

const aacExportUsersFailed = (message) => {
    return {
        type: appAccessControlConstants.EXPORT_USERS_FAILURE,
        payload:{
            loading: false,
            error: true,
            message
        }
    }
}
const aacExportUsersSuccess = () => {
    return {
        type: appAccessControlConstants.EXPORT_USERS_SUCCESS,
        payload: {
            ...exportUsersInitialstate()
        }
    }
}

export const aacExportUsersAction = (listFilterArray) => {
    let url = '/appaccess/export';
    listFilterArray = [ ...(listFilterArray || []) , { id:'zone', value: getTimezoneName() } ];
    const SearchArray = listFilterArray.filter((filter) => filter.id !== 'page' && filter.id !== 'size');
    if(SearchArray && SearchArray.length > 0 ) {
        url = queryParser(url,SearchArray);
    }

    return (dispatch) => {
        dispatch(aacExportUsersRequest());
        Request.create(url, {})
        .then((response) => {
            dispatch(aacExportUsersSuccess());
            if(response.status === 204){
                toastr.dismiss();
                toastr.error(response.message);
                return;
            }
            // Display the export success here
            const url = window.URL.createObjectURL(response);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `AuthorisedUsersList_${ (new Date()).getTime() }.csv`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            if(error) {
                handleApiError(error);
                dispatch(aacExportUsersFailed(error.toString()));
            }
        })
    }
}